import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"
import _imports_0 from '../../../../../assets/img/pdf_icon_version4.png'


const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "element-box" }
const _hoisted_3 = { class: "accordion mt-5" }
const _hoisted_4 = { class: "accordion-item" }
const _hoisted_5 = {
  key: 0,
  class: "accordion-body"
}
const _hoisted_6 = { class: "row mt-3" }
const _hoisted_7 = { class: "col-lg-3 col-md-4 col-sm-12 mb-3" }
const _hoisted_8 = { class: "col-lg-9 col-md-8 col-sm-12 mb-3" }
const _hoisted_9 = { class: "row mt-2" }
const _hoisted_10 = { class: "col-lg-3 col-md-4 col-sm-12 mb-3" }
const _hoisted_11 = { class: "col-lg-9 col-md-8 col-sm-12 mb-3" }
const _hoisted_12 = { class: "row mt-2" }
const _hoisted_13 = { class: "col-lg-3 col-md-4 col-sm-12 mb-3" }
const _hoisted_14 = { class: "col-lg-9 col-md-8 col-sm-12 mb-3" }
const _hoisted_15 = { class: "row mt-2" }
const _hoisted_16 = { class: "col-lg-3 col-md-4 col-sm-12 mb-3" }
const _hoisted_17 = { class: "col-lg-9 col-md-8 col-sm-12 mb-3" }
const _hoisted_18 = { class: "row mt-2" }
const _hoisted_19 = { class: "col-lg-3 col-md-4 col-sm-12 mb-3" }
const _hoisted_20 = { class: "col-lg-9 col-md-8 col-sm-12 mb-3" }
const _hoisted_21 = { class: "row mt-2" }
const _hoisted_22 = { class: "col-lg-3 col-md-4 col-sm-12 mb-3" }
const _hoisted_23 = { class: "col-lg-9 col-md-8 col-sm-12 mb-3" }
const _hoisted_24 = { class: "row mt-2" }
const _hoisted_25 = { class: "col-lg-3 col-md-4 col-sm-12 mb-3" }
const _hoisted_26 = { class: "col-lg-9 col-md-8 col-sm-12 mb-3" }
const _hoisted_27 = { class: "accordion-item" }
const _hoisted_28 = {
  key: 0,
  class: "accordion-body"
}
const _hoisted_29 = { class: "d-flex justify-content-center w-100 mt-5" }

import assistedLivingCoachingService from '@/api/Unemployed/AssistedLivingCoaching';
import Loader from '@/components/Loader.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import Datepicker from '@/components/picker/Datepicker.vue';
import {ErrorToast, SuccessToast} from '@/components/VueToast';
import {piniaUserStore} from '@/store/piniaUserStore';
import CoachingOverviewData from '@/views/App/Portal/AssistedLivingCoaching/CoachingOverviewData.vue';
import AccordionItem from '@/views/App/Portal/AssistedLivingCoaching/FirstInterview/AccordionItem.vue';
import Menu from '@/views/App/Portal/AssistedLivingCoaching/Menu.vue';
import useVuelidate from '@vuelidate/core';
import {computed, onMounted, ref} from 'vue';
import {useI18n} from 'vue-i18n';
import {useRoute} from 'vue-router';
import TextEditor from "@/components/TextEditor.vue";
import portalCoachingService from "@/api/Portal/AssistedLivingCoaching";
import {downloadFile} from "@/shared/functions";
import SaveButton from '@/components/button/SaveButton.vue';

interface EmergencyPlanItem {
  title: string;
  description: string;
}

interface WeeklyAndEmergencyPlanFormData {
  coachingId: number;
  mondayDate: string;
  mondayText: string;
  tuesdayDate: string;
  tuesdayText: string;
  wednesdayDate: string;
  wednesdayText: string;
  thursdayDate: string;
  thursdayText: string;
  fridayDate: string;
  fridayText: string;
  saturdayDate: string;
  saturdayText: string;
  sundayDate: string;
  sundayText: string;
  emergencyPlans: EmergencyPlanItem[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Form',
  setup(__props) {

const piniaUserState = piniaUserStore();
const piniaCurrentUser = computed(() => piniaUserState.currentUser.user);

const {t} = useI18n();
const coachingData = ref('');
const calculatedUnitsData = ref();
const route = useRoute();
const coachingId = route.params.id as string;
const isLoaded = ref(false);
const isSubmitting = ref(false);
const activeAccordion = ref<number | null>(1); // Tracks the currently open accordion item

const formData = ref<WeeklyAndEmergencyPlanFormData>({
  coachingId: 0,
  mondayDate: '',
  mondayText: '',
  tuesdayDate: '',
  tuesdayText: '',
  wednesdayDate: '',
  wednesdayText: '',
  thursdayDate: '',
  thursdayText: '',
  fridayDate: '',
  fridayText: '',
  saturdayDate: '',
  saturdayText: '',
  sundayDate: '',
  sundayText: '',
  emergencyPlans: [],
});

const formRules = ref({});

const computedRules = computed(() => formRules.value);
const v$ = useVuelidate(computedRules, formData);

async function submitForm() {
  v$.value.$touch();
  if (v$.value.$invalid) {
    return;
  }

  if (isSubmitting.value) return;
  isSubmitting.value = true;

  try {
    formData.value.coachingId = +coachingId;

    await portalCoachingService.submitWeeklyAndEmergencyPlans(formData.value);
    await getWeeklyAndEmergencyPlansData(coachingId);

    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

async function getWeeklyAndEmergencyPlansData(coachingId: string) {
  try {
    const {data} = await portalCoachingService.getWeeklyAndEmergencyPlans(+coachingId);
    const weeklyAndEmergencyPlansData = data.data
    console.log(weeklyAndEmergencyPlansData)
    formData.value = {
      coachingId: +coachingId,

      mondayDate: weeklyAndEmergencyPlansData.mondayDate ?? '',
      mondayText: weeklyAndEmergencyPlansData.mondayText ?? '',
      tuesdayDate: weeklyAndEmergencyPlansData.tuesdayDate ?? '',
      tuesdayText: weeklyAndEmergencyPlansData.tuesdayText ?? '',
      wednesdayDate: weeklyAndEmergencyPlansData.wednesdayDate ?? '',
      wednesdayText: weeklyAndEmergencyPlansData.wednesdayText ?? '',
      thursdayDate: weeklyAndEmergencyPlansData.thursdayDate ?? '',
      thursdayText: weeklyAndEmergencyPlansData.thursdayText ?? '',
      fridayDate: weeklyAndEmergencyPlansData.fridayDate ?? '',
      fridayText: weeklyAndEmergencyPlansData.fridayText ?? '',
      saturdayDate: weeklyAndEmergencyPlansData.saturdayDate ?? '',
      saturdayText: weeklyAndEmergencyPlansData.saturdayText ?? '',
      sundayDate: weeklyAndEmergencyPlansData.sundayDate ?? '',
      sundayText: weeklyAndEmergencyPlansData.sundayText ?? '',

      emergencyPlans: (weeklyAndEmergencyPlansData.emergencyPlans ?? []).map((plan: any) => ({
        title: plan.title ?? '',
        description: plan.description ?? '',
      })),
    };

  } catch (error) {
    await ErrorToast(error);
  }
}

async function getCoachingData(coachingId: string) {
  try {
    const {data} = await assistedLivingCoachingService.getAssistedLivingCoaching(+coachingId);
    coachingData.value = data.data;

    const {data: calculatedUnits} = await assistedLivingCoachingService.getCalculatedUnits(+coachingId);
    calculatedUnitsData.value = calculatedUnits.data;
  } catch (error) {
    await ErrorToast(error);
  }
}

// Accordion
const toggleAccordion = (index: number) => {
  activeAccordion.value = activeAccordion.value === index ? null : index;
};

const addItem = (type: keyof WeeklyAndEmergencyPlanFormData, newItem: EmergencyPlanItem) => {
  if (Array.isArray(formData.value[type])) {
    (formData.value[type] as EmergencyPlanItem[]).push(newItem);
  }
};

const removeItem = (type: keyof WeeklyAndEmergencyPlanFormData, index: number) => {
  if (Array.isArray(formData.value[type])) {
    (formData.value[type] as EmergencyPlanItem[]).splice(index, 1);
  }
};

onMounted(async () => {
  await getCoachingData(coachingId);
  await getWeeklyAndEmergencyPlansData(coachingId)
  isLoaded.value = true;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PageTemplate, null, {
    default: _withCtx(() => [
      (!isLoaded.value)
        ? (_openBlock(), _createBlock(Loader, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(CoachingOverviewData, {
                coaching: coachingData.value,
                calculatedUnits: calculatedUnitsData.value
              }, null, 8, ["coaching", "calculatedUnits"]),
              _createVNode(Menu, {
                coaching: coachingData.value,
                currentUser: piniaCurrentUser.value
              }, null, 8, ["coaching", "currentUser"]),
              _createElementVNode("form", {
                onSubmit: _withModifiers(submitForm, ["prevent"]),
                novalidate: "",
                class: "mt-4"
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", {
                      class: "accordion-header d-flex justify-content-between align-items-center",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleAccordion(1)))
                    }, [
                      _cache[30] || (_cache[30] = _createElementVNode("h6", { style: { color: 'var(--primary)' } }, "Wochenplan", -1)),
                      _createElementVNode("div", {
                        class: "d-flex align-items-center",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                      }, [
                        _createElementVNode("a", {
                          href: "javascript:void(0)",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(downloadFile)(
                         `/portal/assisted-living-coaching/weekly-plans-pdf/${_unref(coachingId)}`,
                           'wochenplan.pdf'
                         )))
                        }, [...(_cache[29] || (_cache[29] = [
                          _createElementVNode("span", { class: "me-2" }, "Wochenplan PDF", -1),
                          _createElementVNode("img", {
                            src: _imports_0,
                            alt: "PDF",
                            style: {"width":"40px","cursor":"pointer"}
                          }, null, -1)
                        ]))])
                      ])
                    ]),
                    (activeAccordion.value === 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                              _createVNode(Datepicker, {
                                modelValue: formData.value.mondayDate,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.mondayDate) = $event)),
                                label: "Montag Datum",
                                position: "down"
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_8, [
                              _createVNode(TextEditor, {
                                modelValue: formData.value.mondayText,
                                "onUpdate:modelValue": [
                                  _cache[4] || (_cache[4] = ($event: any) => ((formData.value.mondayText) = $event)),
                                  _cache[5] || (_cache[5] = ($event: any) => (formData.value.mondayText = $event))
                                ],
                                inputStyle: { height: '120px' },
                                label: "Beschreibung"
                              }, null, 8, ["modelValue"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                              _createVNode(Datepicker, {
                                modelValue: formData.value.tuesdayDate,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.tuesdayDate) = $event)),
                                label: "Dienstag Datum",
                                position: "down"
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_11, [
                              _createVNode(TextEditor, {
                                modelValue: formData.value.tuesdayText,
                                "onUpdate:modelValue": [
                                  _cache[7] || (_cache[7] = ($event: any) => ((formData.value.tuesdayText) = $event)),
                                  _cache[8] || (_cache[8] = ($event: any) => (formData.value.tuesdayText = $event))
                                ],
                                inputStyle: { height: '120px' },
                                label: "Beschreibung"
                              }, null, 8, ["modelValue"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                              _createVNode(Datepicker, {
                                modelValue: formData.value.wednesdayDate,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.wednesdayDate) = $event)),
                                label: "Mittwoch Datum",
                                position: "down"
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_14, [
                              _createVNode(TextEditor, {
                                modelValue: formData.value.wednesdayText,
                                "onUpdate:modelValue": [
                                  _cache[10] || (_cache[10] = ($event: any) => ((formData.value.wednesdayText) = $event)),
                                  _cache[11] || (_cache[11] = ($event: any) => (formData.value.wednesdayText = $event))
                                ],
                                inputStyle: { height: '120px' },
                                label: "Beschreibung"
                              }, null, 8, ["modelValue"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                              _createVNode(Datepicker, {
                                modelValue: formData.value.thursdayDate,
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formData.value.thursdayDate) = $event)),
                                label: "Donnerstag Datum",
                                position: "down"
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_17, [
                              _createVNode(TextEditor, {
                                modelValue: formData.value.thursdayText,
                                "onUpdate:modelValue": [
                                  _cache[13] || (_cache[13] = ($event: any) => ((formData.value.thursdayText) = $event)),
                                  _cache[14] || (_cache[14] = ($event: any) => (formData.value.thursdayText = $event))
                                ],
                                inputStyle: { height: '120px' },
                                label: "Beschreibung"
                              }, null, 8, ["modelValue"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              _createVNode(Datepicker, {
                                modelValue: formData.value.fridayDate,
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((formData.value.fridayDate) = $event)),
                                label: "Freitag Datum",
                                position: "down"
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_20, [
                              _createVNode(TextEditor, {
                                modelValue: formData.value.fridayText,
                                "onUpdate:modelValue": [
                                  _cache[16] || (_cache[16] = ($event: any) => ((formData.value.fridayText) = $event)),
                                  _cache[17] || (_cache[17] = ($event: any) => (formData.value.fridayText = $event))
                                ],
                                inputStyle: { height: '120px' },
                                label: "Beschreibung"
                              }, null, 8, ["modelValue"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, [
                              _createVNode(Datepicker, {
                                modelValue: formData.value.saturdayDate,
                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((formData.value.saturdayDate) = $event)),
                                label: "Samstag Datum",
                                position: "down"
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_23, [
                              _createVNode(TextEditor, {
                                modelValue: formData.value.saturdayText,
                                "onUpdate:modelValue": [
                                  _cache[19] || (_cache[19] = ($event: any) => ((formData.value.saturdayText) = $event)),
                                  _cache[20] || (_cache[20] = ($event: any) => (formData.value.saturdayText = $event))
                                ],
                                inputStyle: { height: '120px' },
                                label: "Beschreibung"
                              }, null, 8, ["modelValue"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("div", _hoisted_25, [
                              _createVNode(Datepicker, {
                                modelValue: formData.value.sundayDate,
                                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((formData.value.sundayDate) = $event)),
                                label: "Sonntag Datum",
                                position: "down"
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_26, [
                              _createVNode(TextEditor, {
                                modelValue: formData.value.sundayText,
                                "onUpdate:modelValue": [
                                  _cache[22] || (_cache[22] = ($event: any) => ((formData.value.sundayText) = $event)),
                                  _cache[23] || (_cache[23] = ($event: any) => (formData.value.sundayText = $event))
                                ],
                                inputStyle: { height: '120px' },
                                label: "Beschreibung"
                              }, null, 8, ["modelValue"])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", {
                      class: "accordion-header d-flex justify-content-between align-items-center",
                      onClick: _cache[26] || (_cache[26] = ($event: any) => (toggleAccordion(2)))
                    }, [
                      _cache[32] || (_cache[32] = _createElementVNode("h6", { style: { color: 'var(--primary)' } }, "Notfallplan", -1)),
                      _createElementVNode("div", {
                        class: "d-flex align-items-center",
                        onClick: _cache[25] || (_cache[25] = _withModifiers(() => {}, ["stop"]))
                      }, [
                        _createElementVNode("a", {
                          href: "javascript:void(0)",
                          onClick: _cache[24] || (_cache[24] = ($event: any) => (_unref(downloadFile)(
                         `/portal/assisted-living-coaching/emergency-plans-pdf/${_unref(coachingId)}`,
                           'Notfallplan.pdf'
                         )))
                        }, [...(_cache[31] || (_cache[31] = [
                          _createElementVNode("span", { class: "me-2" }, "Notfallplan PDF", -1),
                          _createElementVNode("img", {
                            src: _imports_0,
                            alt: "PDF",
                            style: {"width":"40px","cursor":"pointer"}
                          }, null, -1)
                        ]))])
                      ])
                    ]),
                    (activeAccordion.value === 2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                          _createVNode(AccordionItem, {
                            title: "",
                            items: formData.value.emergencyPlans,
                            itemTitleLabel: "Umstände",
                            itemDescriptionLabel: "Maßnahmen",
                            onAddItem: _cache[27] || (_cache[27] = (newItem) => addItem('emergencyPlans', newItem)),
                            onDeleteItem: _cache[28] || (_cache[28] = (index) => removeItem('emergencyPlans', index))
                          }, null, 8, ["items"])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createVNode(SaveButton, {
                    label: _ctx.$t('general.button.save'),
                    loading: isSubmitting.value
                  }, null, 8, ["label", "loading"])
                ])
              ], 32)
            ])
          ]))
    ]),
    _: 1
  }))
}
}

})